<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close>
			<template #default>
				<el-form ref="form" :model="form" label-width="80px" size="mini">
					<el-form-item label="商品编码">
						<el-input disabled v-model="form.goodscode"></el-input>
					</el-form-item>
					<el-form-item label="商品名称">
						<el-input disabled v-model="form.goodsname"></el-input>
					</el-form-item>
					<el-form-item label="操作人">
						<staff disabled :value="form.staffid" />
					</el-form-item>
					<el-form-item label="操作类型" required>
						<el-select v-model="form.type" placeholder="请选择">
							<el-option label="运营" :value="1"></el-option>
							<el-option label="推广" :value="2"></el-option>
						</el-select>	
					</el-form-item>
					<el-form-item label="操作内容" required>
						<el-input type="textarea" v-model="form.content"></el-input>
					</el-form-item>
				</el-form>
			</template>
			<template #footer>
				<vxe-button status="primary" content="提交" @click="submit"></vxe-button>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		name: 'bi',
		props: {
			row: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				modal_title: '新增操作',
				modal_width: 600,
				modal_height: 400,
				form: {
					goodscode: null,
					goodsname: null,
					type:null,
					staffid: this.$store.state.system.user.id,
					content: null
				}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			if (this.row) {
				this.form.goodscode = this.row.code
				this.form.goodsname = this.row.title
			}
		},
		computed: {

		},
		methods: {
			submit() {
				this.modal_loading = true
				this.$api.BIshopgoods.addOperate(this.form).then(() => {
					this.$message.success('操作成功')
					this.modal_loading = false
					this.$emit('submit')
					this.modal_cancel()
				}, () => {
					this.modal_loading = false
				})
			}
		},
		components: {
			staff
		}
	}
</script>